module.exports = __webpack_public_path__ + "static/logo-96d62089b4bbe963c4071b39947b3941.svg";